import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './styles'

const PinInput = ({ pinDigits, handleChange, idPrefix }) => {
  const inputs = Array.from(
    { length: pinDigits },
    (_, id) => ({
      id,
      ref: useRef(),
    })
  )
  const pinSelc = useSelector(stateSelector => stateSelector.pinAcceptance)
  const [enteredPin, setEnteredPin] = useState('')
  useEffect((state) => {
    const currentDigit = enteredPin.length
    if (currentDigit < pinDigits) {
      focusField(currentDigit)
      return
    }
    handleChange(enteredPin)
  }, [enteredPin])

  useEffect(() => {
    if (pinSelc.pin) {
      clear()
    }
  }, [pinSelc])

  const handleInput = (e) => {
    const inputPin = inputs.map(input => input.ref.current.value).join('')
    if (!inputPin.match(/^([0-9]){1,4}$/)) {
      // eslint-disable-next-line no-param-reassign
      e.target.value = ''
      return
    }
    setEnteredPin(inputPin)
  }

  const clear = () => {
    setEnteredPin('')
    inputs.forEach((input) => {
      input.ref.current.value = '' // eslint-disable-line no-param-reassign
    })
    focusField(0)
  }

  const handleClick = () => {
    const currentDigit = enteredPin.length
    if (currentDigit < pinDigits) {
      focusField(currentDigit)
    }
  }

  const handleKeyDown = (event) => {
    const key = event.keyCode || event.charCode
    // catch del or backspace key
    if (key === 8 || key === 46) {
      const currentDigit = enteredPin.length
      // if we're on the first digit, we don't need to do anything
      if (!currentDigit) return
      if (currentDigit === 1) {
        clear()
      }
      const currentInput = inputs?.[currentDigit]?.ref?.current
      if (!currentInput) return

      // if there's no value in the current field, focus the previous field
      if (currentInput.value === '') {
        focusField(currentDigit - 1)
      }
    } else if (key < 48 || key > 57) {
      // ignore non-numeric keys
      event.preventDefault()
    }
  }

  const focusField = (index) => {
    inputs[index].ref.current.focus()
  }

  return (
    <div className="PinInput">
      { inputs.map(item => (
        <span key={item.id}>
          <label
            htmlFor={`${idPrefix}pin-${item.id}`}
            aria-hidden
          >
            PIN digit {item.id + 1}
          </label>
          <input
            className={`${idPrefix}-pin`}
            id={`${idPrefix}pin-${item.id}`}
            aria-label={item.id}
            type="password"
            inputMode="numeric"
            maxLength="1"
            autoComplete="new-password"
            required
            pattern="^[0-9]"
            ref={item.ref}
            value={enteredPin[item.id] || ''}
            onInput={handleInput}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
          />
        </span>
      ))}
      <style jsx>{styles}</style>
    </div>
  )
}

PinInput.propTypes = {
  pinDigits: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
  idPrefix: PropTypes.string,
}

PinInput.defaultProps = {
  pinDigits: 4,
  idPrefix: '',
}

export default PinInput
